var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustedIconGlobeF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 7.79005 7.79005",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.89503 0C1.74727 0 0 1.74727 0 3.89503C0 4.55608 0.165998 5.17888 0.457795 5.72474C0.873518 6.50263 1.54535 7.12361 2.36016 7.47435C2.83143 7.6772 3.35022 7.79005 3.89503 7.79005C6.04279 7.79005 7.79005 6.04278 7.79005 3.89503C7.79005 1.74727 6.04279 0 3.89503 0Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedIconGlobeF);
export default __webpack_public_path__ + "static/media/trusted-icon-globe-f.a24a346262cea221444c576c8e50b545.svg";
export { ForwardRef as ReactComponent };